import React, { ReactElement, useEffect } from 'react';

import { useWizardMultistep } from '../../../hooks';
import { WizardStep } from '../../../types';

type WizardMultistepProps = {
    children: Array<ReactElement>;
    initialStepId?: WizardStep;
};

function WizardMultistep({ children, initialStepId }: WizardMultistepProps): ReactElement<'div'> | null {
    const { currentStep, jumpToStep, registerStep } = useWizardMultistep();

    useEffect(() => {
        initialStepId && jumpToStep(initialStepId);
    }, []);

    useEffect(() => {
        React.Children.forEach(children, (child) => {
            if (child.props.id) {
                registerStep({
                    id: child.props.id,
                    nextStepId: child.props.nextStepId,
                    phaseIndex: child.props.phaseIndex,
                    completed: child.props.initiallyCompleted,
                });
            }
            return null;
        });
    }, [children]);

    return (
        <>
            {React.Children.map(children, (child) => {
                // display currently active step
                if (child.props.id === currentStep?.id) {
                    return React.cloneElement(child);
                }
                return null;
            })}
        </>
    );
}

export default WizardMultistep;
